import { AfterViewInit, ChangeDetectorRef, Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[govFieldFocus]'
})
export class FieldFocusDirective implements AfterViewInit {

  constructor(private renderer: Renderer2, private elementRef: ElementRef, private cdr: ChangeDetectorRef) { }

  ngAfterViewInit() {
    this.renderer.selectRootElement(this.elementRef.nativeElement).focus();
    // força o angular a recarregar a detecção de alterações no HTML para evitar erro ao setar o foco
    this.cdr.detectChanges();
  }
}
